import React, { useEffect } from 'react';

import Main from './ui';

import { useClickStreamContext } from '../../ClickStream';
import useUserData from 'hooks/useUserData';

const MANAGER_USER_TYPE = 'manager';

const MainLayout = ({ children, ready = true }: React.PropsWithChildren<{ ready?: boolean }>) => {
  const { logViewPage } = useClickStreamContext();
  const userData = useUserData();

  useEffect(() => {
    logViewPage?.();
  }, []);
  return <Main ready={ready}>{children}</Main>;
};

export default MainLayout;
